export default __webpack_public_path__ + "static/media/CascadeFalls.9290f34f.jpg";